


















































import VueOptions from '@utils/VueOptions'
import AudienceListingThumbnail from '@ui/cards/AudienceListingThumbnail'
import FeedCardCenter from '@ui/Campaign/pipeline/EventFeed/FeedCardCenter'

settings =
  name: 'OfferResourceListItem'

  resources:
    offer:
      resourceName: 'offer'
      slug: 'offers/:item.id'
      fetch: false

  vue:
    props: ['item', 'actions']

    components: {
      AudienceListingThumbnail,
      FeedCardCenter,
    }

    computed:
      audienceListing: -> @ctxAudienceListing @item
      vendorListing: -> @ctxVendorListing @item
      listing: -> if @audienceListing.id then @audienceListing else @vendorListing
      activationPlan: -> @item.activation_plan
      shippingArea: -> @ctxShippingArea @item

      submittedDate: ->
        dayjs(@item.submitted_at).format('MMM DD, YYYY')

      isProductSampling: ->
        @item.spaces_purchased[0].includes 'sampling'

      hasShippingArea: ->
        @isProductSampling and !!@ctxShippingArea(@item).id

      isSubmitted: -> @item.state is 'submitted'
      isAccepted: -> @item.state is 'accepted'
      isExpired: -> @item.state is 'expired'
      isDenied: -> @item.state is 'denied'

      earliestShippingDate: ->
        starts = @activationPlan.start_date
        earliest = @shippingArea.delivery_window?.earliest || 3
        dayjs(starts).subtract(earliest, 'days').format('MMM DD')
      latestShippingDate: ->
        starts = @activationPlan.start_date
        latest = @shippingArea.delivery_window?.latest || 1
        dayjs(starts).subtract(latest, 'days').format('MMM DD')

      state: ->
        states =
          submitted:
            label: 'Pending'
            style: 'text-yellow-dark'
            borderStyle: 'border-yellow-dark'
            badgeStyle: 'bg-yellow-dark text-white'
            iconClass: 'fas fa-comment-dots'
          accepted:
            label: 'Accepted'
            style: 'text-green'
            borderStyle: 'border-white'
            badgeStyle: 'bg-green text-white'
            iconClass: 'far fa-check'
          expired:
            label: 'Expired'
            style: 'text-grey'
            borderStyle: 'border-white'
            badgeStyle: 'bg-grey text-white'
            iconClass: 'fas fa-clock'
          denied:
            label: 'Rejected'
            style: 'text-red-light'
            borderStyle: 'border-white'
            badgeStyle: 'bg-red text-white'
            iconClass: 'far fa-times'
          default:
            label: @$options.filters.formatTitle(@item.state)
            style: 'text-grey'
            borderStyle: 'border-white'
            badgeStyle: 'bg-grey text-white'
            iconClass: 'fas fa-exclamation'
        states[@item.state] || states['default']

    methods:
      hiNavToOffer: ->
        @$router.push { name: 'OfferShowPage', params: { offerId: @item.id } }

      hiRequestExtension: ->
        @triggerResource 'offer', 'request_extension', { offer_id: @item.id }

      hiUndo: ->
        @triggerResource 'offer', 'revert_choice', { offer_id: @item.id }

      promptToSetShippingArea: ->
        # @actions.promptToSetShippingArea @item

export default VueOptions.vue settings
